<template>
  <div class="page-inner login-form">
    <v-form ref="form">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>아이디(휴대폰 번호)</v-list-item-title>

          <v-text-field
            solo
            height="52"
            label="아이디"
            required
            type="number"
            v-model="loginId"
            :rules="[loginIdRules.required, cellRules.min, cellRules.max]"
          />
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>비밀번호</v-list-item-title>
          <!-- 
            :rules="[passwordRules.required, passwordRules.counter]" -->
          <v-text-field
            solo
            height="52"
            label="비밀번호"
            required
            v-model="password"
            :append-icon="pwShow ? 'mdi-eye' : 'mdi-eye-off'"
            :type="pwShow ? 'text' : 'password'"
            @click:append="pwShow = !pwShow"
            :rules="[loginPasswordRules.required, loginPasswordRules.counter]"
          />
        </v-list-item-content>
      </v-list-item>

      <v-btn
        class="mt-3"
        color="primary"
        x-large
        depressed
        block
        rounded
        @click="onClickSignIn"
        >로그인</v-btn
      >
    </v-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
const rulesService = require("@/utils/rules.js");
import Cookies from "js-cookie";

export default {
  components: {},
  data() {
    return {
      step: "login",
      userData: null,
      currentMode: "",
      kakaoAccount: null,
      isDev: process.env.NODE_ENV === "development",
      pwShow: false,
      loginId: "",
      password: "",
      loginIdRules: rulesService.loginIdRules(),
      cellRules: rulesService.cellRules(),
      loginPasswordRules: rulesService.loginPasswordRules(),
    };
  },
  mounted() {
    // 개발모드에서 처리
    if (this.isDev) {
      // this.loginId = "t@predict.kr";
      // this.password = "12345678!";
      // this.loginId = "t4@predict.kr";
      // this.password = "predict6";
      // this.loginId = "01067403235";
      // this.password = "123456789!";
      // this.loginId = "01067403247";
      // this.password = "123456789!";
    }
    if (
      Cookies.get("bayerFarmIsSaveLoginId") !== null &&
      Cookies.get("bayerFarmIsSaveLoginId") !== undefined &&
      Cookies.get("bayerFarmIsSaveLoginId") !== ""
    ) {
      this.loginId = Cookies.get("bayerFarmIsSaveLoginId");
    }
  },
  methods: {
    onClickSignIn() {
      if (!this.$refs.form.validate()) return;
      this.$emit("onClickSignInEmit", this);
    },
    // moveTo(to) {
    //   this.$emit("moveToEmit", to);
    // },
    ...mapActions(["saveDataPreLoginQuery"]),
  },
};
</script>

<style lang="scss">
.page-inner.login-form {
  padding-bottom: 0;

  .v-list-item {
    padding: 0;

    .v-list-item__content {
      padding: 0;
    }

    .v-list-item__title {
      font-size: 14px;
      font-weight: bold;
      padding: 0 15px 0;
      color: $primary-color;

      .asterisk {
        color: $text-red;
      }
    }
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox  */
  input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>